import './index.scss'
import {isGutenbergEditorVisible} from "../../src/scripts/helpers";

function init(scope = document) {
    const nodeSelectors = {
        container: '[js-interactive-banner="container"]',
        image: '[js-interactive-banner="image"]',
        imageTrigger: '[js-interactive-banner="image-trigger"]',
    }

    const containers = scope.querySelectorAll(nodeSelectors.container)

    if (!containers.length) return

    containers.forEach((container) => {
        let images = container.querySelectorAll(nodeSelectors.image)
        let imageTriggers = container.querySelectorAll(nodeSelectors.imageTrigger)

        imageTriggers.forEach(trigger => {
            trigger.addEventListener('mouseenter', () => {
                let target = trigger.getAttribute('data-target')

                images.forEach((image, index) => {
                    image.classList.remove('image-holder--active')

                    if( index === parseInt(target) ) {
                        image.classList.add('image-holder--active')
                    }
                })
            })

            trigger.addEventListener('mouseleave', () => {
                images.forEach((image, index) => {
                    image.classList.remove('image-holder--active')
                })
            })
        })
    })
}

document.addEventListener('DOMContentLoaded', () => {
    if ( window.acf ) {
        // Only in block editor preview
        window.acf.addAction('render_block_preview/type=interactive-banner', ($block) => {
            const blockEl = $block[0] || $block;
            init(blockEl);
        });
    } else if( !isGutenbergEditorVisible() ) {
        // Only in frontend
        init()
    }
});